import { WebUtil }     from '@/utils/webUtil.js'
import { SessionUtil } from '@/utils/sessionUtil.js'
import { AjaxUtil }    from '@/utils/ajaxUtil.js'
import AxiosUtil       from  '@/utils/AxiosUtil.js'
import store           from '@/store'
import router          from '@/router'

export const ComUtil = {

    checkNumber : function (event){
        return ((event.charCode >= 48 && event.charCode <= 57) || event.charCode == 0);
    },

    checkNumAndEng : function (str){
        var err = 0;
        for (var i=0; i<str.length; i++)  {
            var chk = str.substring(i,i+1);
            if(!chk.match(/[0-9]|[a-z]|[A-Z]/)) {
                err = err + 1;
            }
        }
        return err;
    },

    // jQuery.fn.serializeObject = function() {
    //     var arrayData, objectData;
    //     arrayData = this.serializeArray();
    //     objectData = {};
    //     $.each(arrayData, function() {
    //     var value;
    //     if (this.value != null) {
    //         value = this.value;
    //     } else {
    //         value = '';
    //     }
    //     if (objectData[this.name] != null) {
    //         if (!objectData[this.name].push) {
    //         objectData[this.name] = [objectData[this.name]];
    //         }
    //         objectData[this.name].push(value);
    //     } else {
    //         objectData[this.name] = value;
    //     }
    //     });
    //     return objectData;
    // };

    // jQuery.fn.serializefiles = function() {
    //     var formData = new FormData();
    //     $.each($(this).find("input[type='file']"), function(i, tag) {
    //         $.each($(tag)[0].files, function(i, file) {
    //             formData.append(tag.name, file);
    //         });
    //     });
    //     var params = this.serializeArray();
    //     $.each(params, function (i, val) {
    //         formData.append(val.name, val.value);
    //     });
    //     return formData;
    // };

    appendFormdata : function(pFormData, data, name){
        name = name || '';
        if (typeof data === 'object'){
            $.each(data, function(index, value){
                if (name == ''){
                    //console.log("index : "+index);
                    appendFormdata(pFormData, value, index);
                } else {
                    appendFormdata(pFormData, value, name + '['+index+']');
                }
            })
        } else {
            pFormData.append(name, data);
        }
    },

    valid : function(f) {
        f.value = removeEmoji(f.value);
    },

    removeEmoji : function(val) {
        if(!val || val == '') return val;
        return val.replace(/([\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2694-\u2697]|\uD83E[\uDD10-\uDD5D])/g, '');
    },

    // var priceRegExp = /^\d*(\.\d{0,2|)?$/;
    checkPrice : function(_this, divId)  {
        var temp = _this.value; // .toLowerCase();
        if(!/^\d*(\.\d{0,2|)?$/.test(temp)){
            alert("형식이 올바르지 않습니다.");
            return;
        }
    },

    checkStock : function(_this)  {
        var temp = _this.value; // .toLowerCase();
        temp = temp.replace(/[^0-9]/gi, '');
        _this.value = temp;
        if(_this.value.length>20){
            _this.value =_this.value.substring(0, 20);
        }
    },

    validCurrency : function(value){
        var regex = /^[1-9]\d*(((,\d{3}){1})?(\.\d{0,2})?)$/;
        if (regex.test(value))
        {
            var twoDecimalPlaces = /\.\d{2}$/g;
            var oneDecimalPlace = /\.\d{1}$/g;
            var noDecimalPlacesWithDecimal = /\.\d{0}$/g;

            if(value.match(twoDecimalPlaces ))
            {
                return value;
            }
            if(value.match(noDecimalPlacesWithDecimal))
            {
                return value+'00';
            }
            if(value.match(oneDecimalPlace ))
            {
                return value+'0';
            }
            return value+".00";
        }
        return null;
    },

    clone : function(obj) {
        if (obj === null || typeof (obj) !== 'object')
            return obj;
        var copy = obj.constructor();
        for ( var attr in obj) {
            if (obj.hasOwnProperty(attr)) {
                copy[attr] = obj[attr];
            }
        }
        return copy;
    },

    // HTML <> 안의 내용을 지운다.
    removeHTML : function(repStr) {
        repStr = repStr.replaceAll("<BR>", "=BR=").replaceAll("<br>", "=BR=").replaceAll("<p>", "=BR=").replaceAll("<P>", "=BR=");
        var objStrip = /[<][^>]*[>]/gi;
        var objStrip2 =  /<title>(.*?)<\/title>/gi;
        repStr = repStr.replace(objStrip2, "");
        return repStr.replace(objStrip, "").replaceAll("=BR=", "<br>");
    },

    // HTML <> 안의 내용을 지운다.
    removeHTMLAll : function(repStr) {
        var objStrip = /[<][^>]*[>]/gi;
        return repStr.replace(objStrip, "");
    },

    // HTML <> 안의 내용을 지운다.
    isTagHTML : function(repStr) {
        // console.log("repStr : " + repStr);
        var objStrip = /[<][^>]*[>]/gi;
        var repStr2 = repStr.replace(objStrip, "");
        // console.log("repStr2 : " + repStr2);
        if (repStr != repStr2) return true;
        else return false;
    },

    // String.prototype.replaceAll = replaceAll;
    replaceAll : function(strValue1, strValue2) {
        var strTemp = this;
        strTemp = strTemp.replace(new RegExp(strValue1, "g"), strValue2);
        return strTemp;
    },

    // 이미지 확장자 체크
    checkImgFileName : function(fileName) {
        var isErr = false,
            ext = [];
        var sarry = fileName.split("\\");	// 선택된 이미지 화일의 풀 경로

        // 파일 존재 여부 검사
        if (sarry.length <= 0) {
            return false;
        }

        // 확장자 추출
        ext = sarry[sarry.length - 1].split(".");
        // 확장자 존재 여부 검사
        if (ext.length <= 0) {
            return false;
        }
        if (ext[ext.length - 1].toLowerCase() != "jpg" &&
            ext[ext.length - 1].toLowerCase() != "jpeg" &&
            ext[ext.length - 1].toLowerCase() != "png") {

            Swal.alert(["확장자명이 .jpeg, .jpg, .png만 사용 가능합니다.", "warning"]);
            return false;
        }

        return true;
    },

    delSpecialChar : function(valueStr){
        // console.log(valueStr);
        var re =/[\~!@#$%<>^&*\\()\=+_|'"]/gi;
        if (re.test(valueStr)) {
            Swal.alert(["Do not use space or special character.", "warning"]);
            valueStr = valueStr.replace(re,"");
        }
        // console.log(valueStr);
        return valueStr;
    },

    delSpecialCharNoAlert : function(valueStr){
        // console.log(valueStr);
        var re =/[\~!@#$%<>^&*\\()\=+_|'"]/gi;
        if (re.test(valueStr)) {
            valueStr = valueStr.replace(re,"");
        }
        // console.log(valueStr);
        return valueStr;
    },

    limitCharSize : function(valueStr, limitLen) {
        if (String(valueStr).length > limitLen) {
            Swal.alert([limitLen + '자 이내로 작성해 주세요.', "warning"]);
            valueStr = String(valueStr).substring(0, limitLen);
        }
        return valueStr;
    },

    limitByteSize : function(valueStr, limitByte) {
        console.log(valueStr.value);
        var mbytes = 0;
        for(i=0; i < String(valueStr.value).length ; i++) {
            var ch = String(valueStr.value).charAt(i)
            if(escape(ch).length > 4) {
                mbytes += 2;
            } else if(ch == '\n') {
                if(String(valueStr.value).charAt(i-1) != '\r') {
                    mbytes += 1;
                }
            } else {
                mbytes += 1;
            }
            if(mbytes > limitByte) {
                valueStr.value = String(valueStr.value).substr(0,i);
                Swal.alert([$.t('common.valid.input.length.byte', {0: limitByte}), 'warning']);
                break;
            }
        }
        return valueStr.value;
    },

    onlyNumCheck : function(valueStr) {
        var re = /^[0-9\r\n]+$/;
        if (!re.test(valueStr)) {
            //Swal.alert([$.t('common.numinert.chk'), 'warning']);
            valueStr = String(valueStr).replace(/[^0-9]/g,'');
        }

        // if(valueStr == '') {
        //     valueStr = 0;
        // }
        return valueStr;
    },

    onlyNumCheck : function(valueStr, option) {
        var re = /^[0-9\r\n]+$/;
        var reg = /^[+\-]?\d+(?:[.]\d+)?$/g;
        //Option(1) : 오직 숫자만 허용 시
        if(!option || option == 1) {
            if (!re.test(valueStr)) {
                Swal.alert([$.t('common.numinert.chk'), 'warning']);
                valueStr = String(valueStr).replace(/[^0-9]/g,'');
            }
        }
        //Option(2) : +- 기호를 제외한 수숫점까지 허용 시
        if(option && option == 2) {
            re = /^[0-9.\r\n]+$/;
            if (!re.test(valueStr)) {
                Swal.alert([$.t('common.numinert.chk'), 'warning']);
                valueStr = String(valueStr).replace(/[^0-9.]/g,'');
            }
        }

        if(String(valueStr).startsWith('.')) {
            valueStr = '0'+String(valueStr);
        }
        //console.log($.isNumeric(valueStr));

        //if (!reg.test(valueStr)) {
        if (!$.isNumeric(valueStr)) {
        Swal.alert([$.t('common.numinert.chk'), 'warning']);
        //Option(3) : +-, 소숫점 까지 모두 허용
        if(option && option == 3) {
            valueStr = String(valueStr).replace(/[^0-9.]/g,'');
        }
        reg = /^[+\-]?\d+(?:[.]\d+)?/g;
        var matches = reg.exec(valueStr);
        //console.log(matches);
        if(matches && matches.length > 0) {
            valueStr = matches[0];
        } else {
            valueStr = '';
        }
        }

        return valueStr;
    },

    checkNum : function(checkTxt) {
        var isContain = false,
            pattern = /^[0-9\r\n]+$/;

        if (pattern.test(checkTxt)) {
            isContain = true;
        }
        return isContain;
    },

    numberLock : function(valueStr, $event) {
        var key = ($event.which) ? $event.which : $event.keyCode;
        var re = /[^0-9\r\n]+/gm;
        if(!((key == 8) || (key == 9) || (key == 13) || (key == 16) || (key == 37) || (key == 39) || (key == 116))
            || ($event.type == "keyup" && $event.ctrlKey && key == 86)){
            if(re.test(valueStr)) {
                Swal.alert([$.t('common.numinert.chk'), 'warning']);
                valueStr = valueStr.replace(/[^0-9\r\n]+/gm,"");
                return valueStr;
            }
        }
        return valueStr;
    },


    // Is Url (http://, https://)
    // @param strUrl
    
    isValidUrl : function(strUrl) {
        var expUrl = /^http[s]?\:\/\//i;
        return expUrl.test(strUrl);
    },

    //입력값 검사(이메일), chk_err_emailaddress_validstring
    isValidEmail : function(email) {
        //var re = /^(([^<>()[]\\.,;:\s@\"]+(\.[^<>()[]\\.,;:\s@\"]+)*)|(\".+\"))@(([[0-9]{1,3}\??.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        //alert(re.test(email));

        //return email.match(re);
        // if(!re.test(email)) {
        //     return false
        // }
        // return true;
        return re.test(email);
    },

    //입력값 검사(전화번호), Phone number input format is incorrect.
    isValidPhoneNumber : function(number) {
        var re = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
        re = /^[+]*[(]{0,1}[0-9]{1,3}[)]{0,1}[-\s\./0-9]*$/g;
        return re.test(number);
    },

    // at least one number, one lowercase and one uppercase letter
    // at least 8 characters
    isValidPassword : function(str) {
        // /^[a-zA-Z0-9]{10,15}$/
        //var re = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{6,15}$/;
        var re = /^(?=.*\d)(?=.*[a-z])(?=.*[!@#$%^&*()_+]).{8,15}$/;
        return re.test(str);
    },

    //Username must contain only letters, numbers and underscores!
    isValidId : function(str) {
        var re = /^\w+$/;
        return re.test(str);
    },

    //입력값 검사(비밀번호)
    checkPassword : function(fromName) {
        var tmpform = eval("document.frm."+fromName);
        var pwd = tmpform.value;
        if(!/^[a-zA-Z0-9]{10,15}$/.test(pwd)) {
            alert('Passwords must use a combination of letters and numbers 6 ~ 15 characters.');
            return tmpform.focus;
        }

        var chk_num = pwd.search(/[0-9]/g);
        var chk_eng = pwd.search(/[a-z]/ig);

        if(chk_num < 0 || chk_eng < 0) {
            alert('Passwords must use a combination of letters and numbers 6 ~ 15 characters.');
            return tmpform.focus;
        }
    },

    engNumCheck : function(fieldValue) {
        var re = /^[A-Za-z0-9+]*$/;
        if (!re.test(fieldValue)) {
            Swal.alert(['영문, 숫자만 입력 가능합니다.', 'warning']);
            fieldValue = String(fieldValue).replace(/[^A-Za-z0-9]/g,'');
        }

        return fieldValue;
    },

    checkInputValue : function(fieldValue) {
        var pattern = /(^[a-zA-Z0-9 -/:-@\[-\`\{-\~]+$)/;
        if(fieldValue != "" && !pattern.test(fieldValue)){
            Swal.alert(["Please enter alphabet, number and symbol only", "warning"])
                return false;
        }
    },

    getParameters : function (paramName) {
        // 리턴값을 위한 변수 선언
        var returnValue;

        // 현재 URL 가져오기
        var url = location.href;

        // get 파라미터 값을 가져올 수 있는 ? 를 기점으로 slice 한 후 split 으로 나눔
        var parameters = (url.slice(url.indexOf('?') + 1, url.length)).split('&');

        // 나누어진 값의 비교를 통해 paramName 으로 요청된 데이터의 값만 return
        for (var i = 0; i < parameters.length; i++) {
            var varName = parameters[i].split('=')[0];
            if (varName.toUpperCase() == paramName.toUpperCase()) {
                returnValue = parameters[i].split('=')[1];
                return decodeURIComponent(returnValue);
            }
        }
    },

    isValidBizRegNo : function(val) {
        var result = false;

        if(onlyNumCheck(val).length == 10) result = true;
        return result;
    },

    validChecker : function(val, type, size) {
        var result = false;

        if(WebUtil.isNotNull(val)) {
            switch (type) {
            case 'email' :
                return isValidEmail(val);
            case 'phone' :
                return isValidPhoneNumber(val);
            case 'bizno' :
                return isValidBizRegNo(val);
            case 'mxlen' :
                if(size > 0) return val == limitCharSize(val, size);
                break;
            default :
                break;
            }
        }

        return result;
    },

    // 자릿수만큼 0 채우기
    pad : function(n, width) {
        n = n + '';
        return n.length >= width ? n : new Array(width - n.length + 1).join('0') + n;
    }, 

    // 윈도우 팝업 열기
    openWinPop : function(opt) {
        if (WebUtil.isNull(opt.name)) {
            alert("팝업 이름은 필수 항목입니다.");
            return false;
        }

        if (WebUtil.isNull(opt.url)) {
            alert("팝업 주소는 필수 항목입니다.");
            return false;
        }

        // 팝업 넓이
        var popWidth = WebUtil.toInt(opt.width);

        if (popWidth == 0) {
            alert("팝업 넓이는 필수 항목입니다.");
            return false;
        }

        // 팝업 높이
        var popHeight = WebUtil.toInt(opt.height);

        if (popHeight == 0) {
            alert("팝업 높이는 필수 항목입니다.");
            return false;
        }

        // 위치 정보
        var curTop    = window.screenY;
        var curLeft   = window.screenX;
        var curWidth  = document.body.clientWidth;
        var curHeight = window.outerHeight;

        // 부모 넓이
        if (window.parent != window.self) {
            curWidth = window.parent.document.body.clientWidth;
        }

        // 브라우저 정보
        var ua = navigator.userAgent.toLowerCase();

        // 팝업 추가 높이
        var etcHeight = 60;

        // 브라우저 체크
        if (ua.indexOf("msie") != -1 || ua.indexOf("trident") != -1) {
            etcHeight = 36;
        } else if (ua.indexOf("edge") != -1) {
            etcHeight = 90;
        } else if (ua.indexOf("firefox") != -1) {
            etcHeight = 69;
        }

        // 팝업 좌표
        var popTop  = Math.ceil(curTop + ((curHeight - popHeight - etcHeight) / 2));
        var popLeft = Math.ceil(curLeft + ((curWidth - popWidth) / 2));

        // 팝업 옵션
        var popOpt = "top=" + popTop + ", left=" + popLeft + ", width=" + popWidth + ", height=" + popHeight + ", scrollbars=yes, resizable=yes, status=no";

        // 팝업 열기
        window.open(opt.url, opt.name, popOpt);
    },

    // 기간 날짜 구하기
    getPeriodDate : function(type) {
        var nowDate = new Date();
        var dateFormat = dateFormatPattern.toUpperCase();
        var strDt = "";
        var endDt = "";

        if (type == "TODAY") {
            strDt = moment(nowDate).format(dateFormat);
            endDt = moment(nowDate).format(dateFormat);
        } else if (type == "YESTERDAY") {
            strDt = moment(nowDate).add(-1, "days").format(dateFormat);
            endDt = moment(nowDate).add(-1, "days").format(dateFormat);
        } else if (type == "RECENT_WEEK") {
            strDt = moment(nowDate).add(-7, "days").format(dateFormat);
            endDt = moment(nowDate).format(dateFormat);
        } else if (type == "THIS_WEEK") {
            strDt = moment(nowDate).startOf("week").format(dateFormat);
            endDt = moment(nowDate).endOf("week").format(dateFormat);
        } else if (type == "LAST_WEEK") {
            strDt = moment(nowDate).add(-1, "weeks").startOf("week").format(dateFormat);
            endDt = moment(nowDate).add(-1, "weeks").endOf("week").format(dateFormat);
        } else if (type == "RECENT_MONTH") {
            strDt = moment(nowDate).add(-30, "days").format(dateFormat);
            endDt = moment(nowDate).format(dateFormat);
        } else if (type == "THIS_MONTH") {
            strDt = moment(nowDate).startOf("month").format(dateFormat);
            endDt = moment(nowDate).endOf("month").format(dateFormat);
        } else if (type == "LAST_MONTH") {
            strDt = moment(nowDate).add(-1, "months").startOf("month").format(dateFormat);
            endDt = moment(nowDate).add(-1, "months").endOf("month").format(dateFormat);
        } else if (type == "PRE_THREE_MONTH") {
            strDt = moment(nowDate).add(-3, "months").format(dateFormat);
            endDt = moment(nowDate).format(dateFormat);
        } else if (type == "PRE_SIX_MONTH") {
            strDt = moment(nowDate).add(-6, "months").format(dateFormat);
            endDt = moment(nowDate).format(dateFormat);
        } else if (type == "PRE_ONE_YEAR") {
            strDt = moment(nowDate).add(-1, "years").format(dateFormat);
            endDt = moment(nowDate).format(dateFormat);
        }

        return { strDt: strDt, endDt: endDt};
    },

    copyToClipBoard : function(cpValue){
        var t = document.createElement("textarea");
        document.body.appendChild(t);
        t.value = cpValue;
        t.select();
        document.execCommand('copy');
        document.body.removeChild(t);

        // var aux = document.createElement("div");
        // aux.setAttribute("contentEditable", true);
        // //aux.innerHTML = document.getElementById(element_id).innerHTML;
        // aux.innerHTML = cpValue;
        // aux.setAttribute("onfocus", "document.execCommand('selectAll',false,null)");
        // document.body.appendChild(aux);
        // aux.focus();
        // document.execCommand("copy");
        // document.body.removeChild(aux);
    },

    // 비밀번호 형식 체크
    isMemScrtNoError : function(memScrtNo) {

        var num = memScrtNo.search(/[0-9]/g);
        var eng = memScrtNo.search(/[a-z]/ig);
        var spe = memScrtNo.search(/[~!@#$%^&*()_+|<>?:{}\-]/);

        //비밀번호 미입력
        if(memScrtNo.length === 0){
            return true;
        }

        //비밀번호 자리수 8자리 ~ 16자리
        if(memScrtNo.length < 8 || memScrtNo.length > 16){
            return true;
        }

        //비밀번호 공백 미허용
        if(memScrtNo.search(/\s/) != -1){
            return true;
        }

        // 영문,숫자, 특수문자를 혼합
        if(num < 0 || eng < 0 || spe < 0 ){
            return true;
        }

        return false;
    },

    // setAutoLoginYn: function(autoLoginYn) {
    //     const userAgent = navigator.userAgent.toLowerCase();
    //     if ( this.isAndroidApp(userAgent) ) {
    //         return android.setAutoLoginYn(autoLoginYn);
    //     } else if ( this.isIosApp() ) {
    //         return window.webkitURL.messageHandlers.webViewMessageHandler.postMessage();
    //         // webViewMessageHandler 가 앱개발자와 맞춰야 할것
    //     } else {
    //         return '';
    //         // return window.opener.postMEssage(message);
    //     }
    // },

    // getAutoLoginYn: function() {
    //     const userAgent = navigator.userAgent.toLowerCase();
    //     if ( this.isAndroidApp(userAgent) ) {
    //         return android.getAutoLoginYn();
    //     } else if ( this.isIosApp() ) {
    //         return window.webkitURL.messageHandlers.webViewMessageHandler.postMessage();
    //         // webViewMessageHandler 가 앱개발자와 맞춰야 할것
    //     } else {
    //         return '';
    //         // return window.opener.postMEssage(message);
    //     }
    // },

    getFcmToknVal: function() {
        const userAgent = navigator.userAgent.toLowerCase();
        // 안드로이드인 경우
        if ( this.isAndroidApp(userAgent) ) {
            return android.getFcmToknVal();
        // IOS인 경우
        } else if ( this.isIosApp() ) {
            return window.webkitURL.messageHandlers.webViewMessageHandler.postMessage();
            // webViewMessageHandler 가 앱개발자와 맞춰야 할것
        // 웹 인경우
        } else {
            return '';
            // return window.opener.postMEssage(message);
        }
    },

    getTelNo: function() {
        const userAgent = navigator.userAgent.toLowerCase();
        let telNo = '';
        if ( this.isAndroidApp(userAgent) ) {
            telNo = android.getTelNo();
        } else if ( this.isIosApp() ) {
            telNo = window.webkitURL.messageHandlers.webViewMessageHandler.postMessage();
            // webViewMessageHandler 가 앱개발자와 맞춰야 할것
        } else {
            telNo = '';
            // return window.opener.postMEssage(message);
        }
        // console.log(telNo);
        if ( !!telNo && telNo.length > 10 )
        {
            telNo = telNo.slice(-11, telNo.length);
            console.log(telNo);
        }
        else
        {
            // WebUtil.alert("앱에서 실행해 주시기 바랍니다.");
        }

        return telNo;
    },

    sendMessage : function(message) {
        const userAgent = navigator.userAgent.toLowerCase();
        
        if ( this.isAndroidApp(userAgent) ) {
            return android.sendMessage(message);
        } else if ( this.isIosApp() ) {
            return window.webkitURL.messageHandlers.webViewMessageHandler.postMessage(message);
            // webViewMessageHandler 가 앱개발자와 맞춰야 할것
        } else {
            return '';
            // return window.opener.postMEssage(message);
        }
    },

    isApp : function(agent) {
        if ( !!!agent ) {
            agent = navigator.userAgent.toLowerCase()
        }
        if(agent.indexOf('aiband') > -1){
            // console.log('isApp');
            return true;
        }else{
            return false;
        }
    },

    isAndroidApp : function(agent) {
        if ( !!!agent ) {
            agent = navigator.userAgent.toLowerCase()
        }
        if (agent.indexOf('android') > -1) {
            // console.log('isAndroid');
            if ( this.isApp(agent) ) {
                return true;
            } else {
                return false;
            }
        }else{
            return false;
        }
    },

    isIosApp : function(agent) {
        if ( !!!agent ) {
            agent = navigator.userAgent.toLowerCase()
        }
        if ( agent.indexOf("iphone") > -1 || agent.indexOf("ipad") > -1 || agent.indexOf("ipod") > -1 ) {
            // console.log('iphone');
            if ( this.isApp(agent) ) {
                return true;
            } else {
                return false;
            }
        }else{
            return false;
        }
    },

    numberTypeMaxLengCheck : function(obj) {
        if (obj.value.length > obj.maxLength){
            obj.value = obj.value.slice(0, obj.maxLength);
        }
    },

    // GNB 링크
    gnbLink : function(url) {

        var storageDataObj = WebUtil.getStorageData(url, false);

        if(storageDataObj == null){
            storageDataObj = {};
        }

        storageDataObj['scrollY'] = 0;

        WebUtil.setStorageData(url, storageDataObj, false);

        if (window.opener) {
            try {
                window.opener.location.href = url;
                self.close();
            }catch(e){
                location.href = url;
            }
        } else {
            location.href = url;
        }
    },

    //로그인여부 체크
    isLogin : function() {
        return WebUtil.isNotNull(SessionUtil.getUserId());
    },

    logout : function(platform) {
        let $this = this;

        if (window.ReactNativeWebView) {
            window.ReactNativeWebView.postMessage(JSON.stringify({callModuleType : 'LOGOUT_TOKEN'}));
        }

        AxiosUtil.post('/cmon/sys/login/deleteTokn.hb', {userId: SessionUtil.getUserId(), platform: platform});
        $this.clearSession();
        router.push({ name: 'Login' });
        // AjaxUtil.post({
        //     url: '/accnt/logout.ab',
        //     loadYn : false,
        //     reqType: "json",
        //     success: function(response) {
        //         if ( response.rtnCd === '00' ) {
        //             this.clearSession();
        //             SessionUtil.setAutoLoginYn("N");
        //         }
        //     },
        //     error: function(errMsg, response){

        //     },
        //     complete : function(){

        //     }
        // });
    },

    clearSession: function() {
        SessionUtil.clearUserInfo();
        SessionUtil.clearToken();
        SessionUtil.clearUserRoleList();
        // SessionUtil.clearCmonCdList();
        // SessionUtil.clearToken();
        // SessionUtil.clearUserInfo();
        // SessionUtil.clearChildren();
        // store.getters.emitter.emit('onClearChildInfo');

        // console.log(SessionUtil.getToken());
        // console.log(SessionUtil.getUserInfo());
        // console.log(SessionUtil.getChildren());
    },

    // 모바일 웹으로 계속 보기 체크
    checkApp : function() {
        if(!isApp() && WebUtil.getCookie('viewMW') == '') {
            window.addEventListener('DOMContentLoaded', (event) => {
                LayerUtil.confirm({
                    msg: '모바일 웹 화면에서 계속 보시겠습니까?',
                    btnOk: '앱에서 보기',
                    btnCncl: '하루동안 모바일 웹에서 보기',
                    callback: function (resYn) {
                        if (resYn) {

                            var targetUrl = encodeURIComponent(location.href);

                            if(isIosApp()){
                                // 스토어 이동
                                var visitedAt = (new Date()).getTime();
                                setTimeout(
                                function () {
                                    if ((new Date()).getTime() - visitedAt < 2000) {
                                        location.href = "https://apps.apple.com/kr/app/id1506727566";
                                    }
                                }, 500);

                                setTimeout(
                                function () {
                                    location.href = "wonderplace://open?url=" + targetUrl;
                                }, 0);
                            }

                            if(isAndroidApp()){
                                location.href = "Intent://open?url=" + targetUrl + "#Intent;scheme=wonderplace;action=android.intent.action.VIEW;category=android.intent.category.BROWSABLE;package=com.wonder.wonderplace;end";
                            }
                        } else {
                            WebUtil.setCookie("viewMW", true, 1);
                        }
                    }
                });
            });
        }
    },

    // 컨텐츠 높이 및 스크롤 이동
    setContentsData : function() {

        var storageDataObj = WebUtil.getStorageData(location.href.replaceAll(location.origin, ""), false);

        if(storageDataObj != null && storageDataObj['contentsHeight'] != null) {

            $('#content').css('height', parseInt(storageDataObj['contentsHeight']) + "px");

            if (storageDataObj['scrollY'] != null) {

                window.scrollTo(0, storageDataObj['scrollY']);

                if(storageDataObj['scrollY'] > 100) {
                    if(location.href.indexOf("searchResult") == -1) {
                        $('#header .fix_el').addClass('up');
                        $('#header .snb_wrap').addClass('up');
                    }
                }

                scrollTopFixed();
            }
        }else{
            window.scrollTo(0, 0);
        }
    },

    /**
     * 좌우 공백제거
     * str : 문자열
     */
    trim: function(str) {
        if (typeof str === "string") {
            return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
        }

        return str;
    },

}